import axios from 'axios';
import { CapacitorHttp } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { isPlatform } from '@ionic/vue';

export interface ILigaPromoCode {
  id?: number;
  code: string;
  percentOff: number;
  validFrom?: string | null;
  validTo?: string | null;
  active?: boolean;
  maxRedemptions?: number | null;
  maxPerUser?: number;
  targetType?: 'ALL' | 'SUBSCRIPTION' | 'EVENT';
  subscriptionId?: number | null;
  subscriptionTitle?: string | null;
  subscriptionDurationDays?: number | null;
  eventId?: number | null;
  eventTitle?: string | null;
  redemptionCount?: number;
}

const getToken = async (): Promise<string> => {
  const { value } = await Preferences.get({ key: 'jwt' });
  return value || '';
};

const baseUrl = () => process.env.VUE_APP_API_URL || '';

const api = async <T>(method: string, path: string, body?: unknown): Promise<T> => {
  const token = await getToken();
  if (isPlatform('ios') || isPlatform('android')) {
    const headers: Record<string, string> = { Authorization: `Bearer ${token}` };
    const opts: any = { url: `${baseUrl()}api${path}`, method, headers, readTimeout: 60000 };
    if (body != null) {
      headers['Content-Type'] = 'application/json';
      opts.data = JSON.stringify(body);
    }
    const res = await CapacitorHttp.request(opts);
    if (res.status >= 400) throw new Error((res.data as any)?.message || `HTTP ${res.status}`);
    return res.data as T;
  }
  const config: any = { url: `api${path}`, method, headers: { Authorization: `Bearer ${token}` } };
  if (body) config.data = body;
  const { data } = await axios.request<T>(config);
  return data;
};

export default {
  list(): Promise<ILigaPromoCode[]> {
    return api('GET', '/admin/promo-codes');
  },
  get(id: number): Promise<ILigaPromoCode> {
    return api('GET', `/admin/promo-codes/${id}`);
  },
  create(dto: ILigaPromoCode): Promise<ILigaPromoCode> {
    return api('POST', '/admin/promo-codes', dto);
  },
  update(id: number, dto: ILigaPromoCode): Promise<ILigaPromoCode> {
    return api('PUT', `/admin/promo-codes/${id}`, dto);
  },
  remove(id: number): Promise<void> {
    return api('DELETE', `/admin/promo-codes/${id}`);
  },
};
